<template>
  <div>
    <b-row>
      <b-col>
        <label class="mb-2">
          <i class="fa fa-fw fa-image text-muted"></i>
          {{ trans('attach_media_url') }}
          <small class="text-muted">
            <i class="fa fa-fw fa-info-circle" id="media_url"></i>
          </small>
          <b-tooltip target="media_url" triggers="hover">
            {{ trans('attach_media_url_details') }}
          </b-tooltip>
        </label>
      </b-col>
      <b-col class="col-auto">
        <a href="#" class="text-danger" @click.prevent="$emit('close')">
          <i class="fa fa-fw fa-times"></i>
        </a>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-input v-model="image_url" placeholder="https://example.com/image.png" />
        <small v-if="!isMediaUrlValid" class="form-text text-danger text-right">
          {{ trans('invalid_url') }}
        </small>
      </b-col>
      <b-col class="col-auto pl-0">
        <b-button variant="primary" v-b-modal.choose-image>
          {{ trans('media') }}
        </b-button>
      </b-col>
    </b-row>

    <b-modal
      id="choose-image"
      :title="trans('choose_image')"
      hide-footer
    >
      <b-tabs pills>
        <b-tab :title="trans('your_images')" lazy>
          <images-table
            :organization="organization"
            :per-page="3"
            hide-upload
            image-name-only
            no-open
            @choose="onChooseImage"
            class="mt-2"
          ></images-table>
        </b-tab>
        <b-tab title="Pexels" lazy>
          <pexels-table
            :organization="organization"
            :per-page="3"
            image-name-only
            no-open
            @choose="onChooseImage"
            class="mt-2"
          ></pexels-table>
        </b-tab>
      </b-tabs v-model="tab">
    </b-modal>

  </div>
</template>

<script>
  import ImagesTable from './../media/ImagesTable'
  import PexelsTable from './../media/PexelsTable'

  export default {
    props: [
      'organization',
      'value', // v-model
    ],
    components: {
      ImagesTable,
      PexelsTable,
    },
    data() {
      return {
        trans: trans,
        image_url: this.value,
        thumbnail_url: null,
        not_found: false,
      }
    },
    computed: {
      isMediaUrlValid() {
        return _.validateUrl((this.image_url||'').trim())
      },
    },
    methods: {
      onChooseImage(image) {
        this.image_url = image.url
        this.$emit('input', this.image_url)
        this.$bvModal.hide('choose-image')
      },
    },
    mounted() {
      window.sendOutImageComponent = this
    }
  }
</script>